import React, { useContext, useEffect } from "react";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./styles.css";
import {
  BrisanjeOperatera,
  Certifikat,
  DostavaPodataka,
  FourOFour,
  MojiPodaci,
  Odjava,
  Oslobodjenje,
  OstaliOperateri,
  Registracija,
  Upute,
} from "./screens";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AppContainer } from "./components";
import { useKeycloak } from "@react-keycloak/web";
import { Context } from "./context";
import EmailPrijava from "./screens/EmailPrijava";

const DAC7Theme = createTheme({
  typography: {
    fontSize: 12,
  },
  components: {
    MuiFab: {
      styleOverrides: {
        root: {
          width: 33,
          height: 33,
          minHeight: 33,
        },
      },
    },
  },
});

const PrivateRoute = ({ children }: { children?: JSX.Element }) => {
  const { keycloak } = useKeycloak();
  const [data, setData] = useContext(Context);
  useEffect(() => {
    const loadUser = async () => {
      if (!keycloak) return;
      const user = await keycloak.loadUserInfo();
      setData({
        ...data,
        user,
        tokenParsed: keycloak.tokenParsed,
        token: keycloak.token,
      });
    };
    loadUser();
  }, []);

  if (keycloak.authenticated) return <>{children}</>;

  return <Odjava />;
};
const App = () => {
  const { initialized } = useKeycloak();

  if (!initialized) return null;

  return (
    <ThemeProvider theme={DAC7Theme}>
      <Router>
        <Routes>
          <Route path="/404" element={<FourOFour />} />
          <Route path="/registracija" element={<Registracija />} />
          <Route path="/" element={<EmailPrijava />} />
          <Route
            path="/upravljanje-podacima/ostali-operateri"
            element={
              <PrivateRoute>
                <AppContainer>
                  <OstaliOperateri />
                </AppContainer>
              </PrivateRoute>
            }
          />
          <Route
            path="/upravljanje-podacima/oslobodenje"
            element={
              <PrivateRoute>
                <AppContainer>
                  <Oslobodjenje />
                </AppContainer>
              </PrivateRoute>
            }
          />
          <Route
            path="/upravljanje-podacima/upute"
            element={
              <PrivateRoute>
                <AppContainer>
                  <Upute />
                </AppContainer>
              </PrivateRoute>
            }
          />
          <Route
            path="/upravljanje-podacima/brisanje-operatera"
            element={
              <PrivateRoute>
                <AppContainer>
                  <BrisanjeOperatera />
                </AppContainer>
              </PrivateRoute>
            }
          />
          <Route
            path="/upravljanje-podacima/certifikat"
            element={
              <PrivateRoute>
                <AppContainer>
                  <Certifikat />
                </AppContainer>
              </PrivateRoute>
            }
          />
          <Route
            path="/upravljanje-podacima/dostava-podataka"
            element={
              <PrivateRoute>
                <AppContainer>
                  <DostavaPodataka />
                </AppContainer>
              </PrivateRoute>
            }
          />
          <Route
            path="/upravljanje-podacima/moji-podaci"
            element={
              <PrivateRoute>
                <AppContainer>
                  <MojiPodaci />
                </AppContainer>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
